<po-page-default
  [p-actions]="pageActions">

  <po-container class="sr-admin-gates-container" [p-no-border]="true" [p-no-padding]="true">
    <!-- Tela inteira, e não o container: a tabela de controles é mais alta que a janela,
         e o spinner centralizado nela ficava abaixo da dobra ao clicar em Atualizar. -->
    <po-loading-overlay *ngIf="loading" [p-screen-lock]="true"></po-loading-overlay>

    <div class="sr-admin-gates-header">
      <div class="po-font-text-small">
        Pause recursos do Smart Review para todos os usuários.
      </div>
    </div>

    <div class="sr-gates-group">
      <div class="sr-gates-group-title">{{ entryGroupTitle }}</div>
      <po-table
        p-striped="true"
        p-hide-columns-manager
        [p-columns]="columns"
        [p-items]="entryGates">
        <ng-template p-table-cell-template let-column="column" let-row="row">
          <ng-container *ngTemplateOutlet="gateCell; context: { column: column, row: row }"></ng-container>
        </ng-template>
      </po-table>
    </div>

    <div class="sr-gates-group">
      <div class="sr-gates-group-title">{{ entryByTypeGroupTitle }}</div>
      <div class="sr-gates-group-hint">
        Cada tipo é independente: pausar um não afeta os demais.
      </div>
      <div *ngIf="masterAcceptPaused" class="sr-gates-notice">
        <span class="po-icon po-icon-warning sr-gates-notice__icon"></span>
        {{ masterAcceptNotice }}
      </div>
      <div *ngIf="allEntryTypesPaused" class="sr-gates-notice sr-gates-notice--info">
        <span class="po-icon po-icon-info sr-gates-notice__icon"></span>
        {{ allEntryTypesNotice }}
      </div>
      <po-table
        p-striped="true"
        p-hide-columns-manager
        [p-columns]="columns"
        [p-items]="entryByTypeGates">
        <ng-template p-table-cell-template let-column="column" let-row="row">
          <ng-container *ngTemplateOutlet="gateCell; context: { column: column, row: row }"></ng-container>
        </ng-template>
      </po-table>
    </div>

    <div class="sr-gates-group">
      <div class="sr-gates-group-title">{{ executionGroupTitle }}</div>
      <po-table
        p-striped="true"
        p-hide-columns-manager
        [p-columns]="columns"
        [p-items]="executionGates">
        <ng-template p-table-cell-template let-column="column" let-row="row">
          <ng-container *ngTemplateOutlet="gateCell; context: { column: column, row: row }"></ng-container>
        </ng-template>
      </po-table>
    </div>
  </po-container>

  <ng-template #gateCell let-column="column" let-row="row">
    <ng-container *ngIf="column.property === 'label'">
      <div class="sr-gate-label">
        <span>{{ row.label }}</span>
        <span
          class="po-icon po-icon-help sr-gate-help"
          [p-tooltip]="row.tooltip"
          p-tooltip-position="top">
        </span>
      </div>
      <div class="sr-gate-description">{{ row.description }}</div>
    </ng-container>

    <ng-container *ngIf="column.property === 'status'">
      <po-tag
        [p-value]="gateStatusLabel(row)"
        [p-type]="gateStatusType(row)"
        p-inverse="true">
      </po-tag>
    </ng-container>

    <ng-container *ngIf="column.property === 'paused'">
      <po-switch
        *ngIf="row.switchRenderVersion % 2 === 0; else alternateGateSwitch"
        [name]="'gate-' + row.key"
        p-size="small"
        p-label-on="Pausado"
        p-label-off="Liberado"
        [p-value]="row.paused"
        [p-disabled]="row.updating || loading"
        (p-change)="onGateToggle(row, $event)">
      </po-switch>

      <ng-template #alternateGateSwitch>
        <po-switch
          [name]="'gate-' + row.key"
          p-size="small"
          p-label-on="Pausado"
          p-label-off="Liberado"
          [p-value]="row.paused"
          [p-disabled]="row.updating || loading"
          (p-change)="onGateToggle(row, $event)">
        </po-switch>
      </ng-template>
    </ng-container>

    <ng-container *ngIf="column.property === 'updatedBy'">
      {{ row.updatedBy || 'n/d' }}
    </ng-container>

    <ng-container *ngIf="column.property === 'updatedAt'">
      {{ row.updatedAt ? (row.updatedAt | date:'dd/MM/yyyy HH:mm') : 'n/d' }}
    </ng-container>
  </ng-template>

  <po-modal
    #confirmPauseModal
    [p-title]="confirmPauseTitle"
    p-size="sm"
    p-click-out="false"
    [p-primary-action]="confirmPausePrimaryAction"
    [p-secondary-action]="confirmPauseSecondaryAction">
    <p>{{ confirmPauseMessage }}</p>
  </po-modal>

</po-page-default>

<notificationComponentHM></notificationComponentHM>
